














import _ from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";
import { Message } from "@/api/message-api";
import getDate from "date-fns/getDate";
import format from "date-fns/format";
import locale from "date-fns/locale/ja";

@Component({})
export default class MessageList extends Vue {
  @Prop({ default: () => [] }) messages!: Message[];
  @Prop({ default: -1 }) lastReadMessageId!: number;

  get dividers() {
    // 比較対象になる前のメッセージの日付
    const contrast = [new Date(0), ..._.initial(this.messageCreatedList)];
    return _.zip(contrast, this.messageCreatedList).map(([p, d]) => {
      // 前日と日にちが違ったらdividerを設置する
      if (!p || !d) return "";
      if (getDate(p) === getDate(d)) return "";
      return format(d, "yyyy/MM/dd (E)", { locale });
    });
  }

  unread(message: Message, i: number) {
    return (
      i !== this.messages.length - 1 &&
      message.messageId === this.lastReadMessageId
    );
  }

  private get messageCreatedList(): Date[] {
    return this.messages.map(m => m.created);
  }
}
